import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { Badge } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import { getDateLocale2 } from '../../../util/utilFunction';




const FileList = ({ fileList , handleDeleteState ,handleDelete , title ,styleName ,handleDeleteIcon=<DeleteIcon/> ,dense=true }) => {
  
//console.log("fileList ",fileList)


    return (
      fileList.length === 0 ? null : 

  <List dense={dense} className={`shadow border-0 ${styleName}`} color="primary"
  subheader={
    <ListSubheader component="div" id="nested-list-subheader">
      {title}
    </ListSubheader>
  }
  >
                {
                  fileList.map((file,index) => 
                  { 
                     return (
                [      <ListItem key={"list"+file.id}>
                     
                

                      <ListItemText
                        primary={index+1 +' - ' +file.originalName }
                      secondary={ [file.docType==="7" && file.docTypeTitle !== "" ? file.docTypeTitle : <IntlMessages id={"file.doctype."+file.docType}/> , "  ",<Badge>{ getDateLocale2("tr",file.uploadDate)}</Badge> ] }
                      />
                     
                      {handleDeleteState ?
                       <ListItemSecondaryAction>
                       <IconButton aria-label="Delete" onClick={()=> handleDelete(file)}>
                       {handleDeleteIcon} 
                       </IconButton>
                     </ListItemSecondaryAction> 
                     : null  
                    }
             
          
          
                   
                    </ListItem>,
                       index+1 === fileList.length ? null : <Divider light  key={"dvider"+file.id} />
  
                  ]
                    )
                  }
                    )
              
                }
              </List>


         
     
    );
  
}

export default FileList;